app.service("SiteService", ['$rootScope', function ($rootScope) {

    const service = this;

    const SiteModel = function () {
        this.upload_max_filesize = 0;
        this.server_url = 0;
    };

    this.model = new SiteModel();
    const model = this.model;


    service.applyPageVars = function () {

        if (typeof page_vars !== 'undefined' && page_vars) {

            if (page_vars.hasOwnProperty('upload_max_filesize')) {
                service.model.upload_max_filesize = parseInt(page_vars.upload_max_filesize);
            }
            if (page_vars.hasOwnProperty('server_url')) {
                service.model.server_url = $rootScope.site_helper.rtrim(page_vars.server_url, "/");
            }
        }
    }
}]);